'use client';

import React from 'react';
import { motion } from 'motion/react';

interface LoadingDotsProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'white' | 'blue';
}

const LoadingDots: React.FC<LoadingDotsProps> = ({
  className = '',
  size = 'md',
  color = 'primary',
}) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'h-1 w-3';
      case 'md':
        return 'h-2 w-5';
      case 'lg':
        return 'h-3 w-6';
      default:
        return 'h-2 w-5';
    }
  };

  const getColor = (index: number) => {
    const colorMap = {
      white: ['#ffffff', '#f3f4f6', '#e5e7eb'],
      blue: ['#3b82f6', '#60a5fa', '#93c5fd'],
      primary: ['#ffffff', '#dbeafe', '#93c5fd'],
    };

    return colorMap[color]?.[index] || colorMap.primary[index];
  };

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {[0, 1, 2].map((i) => (
        <motion.div
          key={i}
          className={`${getSizeClasses()} rounded-full`}
          style={{
            backgroundColor: getColor(i),
          }}
          animate={{
            scale: [0.6, 1, 0.6],
            opacity: [0.4, 1, 0.4],
          }}
          transition={{
            duration: 1.2,
            repeat: Infinity,
            delay: i * 0.2,
            ease: 'easeInOut',
          }}
        />
      ))}
    </div>
  );
};

export default LoadingDots;
